"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const redux_form_1 = require("redux-form");
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const modal_1 = __importDefault(require("components/common/modal"));
const household_member_fields_1 = __importDefault(require("./household-member-fields"));
require("./household-member-create.scss");
class HouseholdMemberEditor extends React.Component {
    componentDidUpdate() {
        const { isChild, dispatch, selectedEmailAddress, selectedMemberType, selectedMemberTypeFromState } = this.props;
        if (selectedEmailAddress && isChild) {
            dispatch((0, redux_form_1.change)('household-member', 'emailAddress', null));
        }
        // memberType can be changed when there is no birthdate field, but when a user
        // enters a birthdate, we want to change memberType value on the form object
        // based on the birthdate selected
        if (selectedMemberTypeFromState !== selectedMemberType) {
            dispatch((0, redux_form_1.change)('household-member', 'memberType', selectedMemberType));
        }
    }
    onSubmit = (values) => {
        const { submitCreateMemberForm, history, closeMemberEditor } = this.props;
        return submitCreateMemberForm(values).then(() => {
            // if successful, this will set the selectedMember which is needed prior
            // to going to the /settings/household/member page
            closeMemberEditor();
            history.push('/settings/household/member');
        });
    };
    renderHeader = () => {
        return React.createElement("strong", { className: "Modal-title" }, "Add Household Member");
    };
    renderFooter = () => {
        const { closeMemberEditor, submitting, handleSubmit } = this.props;
        return (React.createElement("div", { className: "Grid Add-Member-Footer u-flexJustifyEnd" },
            React.createElement("div", { className: "u-padNone u-xs-padRightSm" },
                React.createElement(teamsnap_ui_1.Button, { mods: "cancel", icon: "dismiss", onClick: closeMemberEditor }, "Cancel")),
            React.createElement("div", null,
                React.createElement(teamsnap_ui_1.Button, { type: "submit", isDisabled: submitting, color: "primary", mods: "u-sizeFull u-spaceNone", icon: submitting ? null : 'check', onClick: handleSubmit(this.onSubmit) },
                    submitting && React.createElement(teamsnap_ui_1.Loader, { type: "spin", style: { width: '13px', height: '13px' } }),
                    "Add Household Member"))));
    };
    render() {
        const { handleSubmit, closeMemberEditor, isChild, selectedMemberType, birthdayChanged, change } = this.props;
        return (React.createElement("form", { id: "household-member", onSubmit: handleSubmit(this.onSubmit), noValidate: true },
            React.createElement(modal_1.default, { hide: closeMemberEditor, renderFooter: this.renderFooter, renderHeader: this.renderHeader, contentLabel: "Household Member Editor" },
                React.createElement("div", { id: "household-member-create-content" },
                    React.createElement(household_member_fields_1.default, { isChild: isChild, birthdayChanged: birthdayChanged, selectedMemberType: selectedMemberType, change: change })))));
    }
}
exports.default = (0, redux_form_1.reduxForm)({
    form: 'household-member',
    enableReinitialize: true, // to load initialValues
})(HouseholdMemberEditor);
